export default "__VITE_ASSET__BQA6ol_g__"